<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <rect
        width="14.5"
        height="22.5"
        x="4.75"
        y=".75"
        stroke="inherit"
        fill="none"
        stroke-width="1.5"
        rx="3.25"
      />
      <path
        fill="inherit"
        stroke="none"
        d="M7 11.36v-.72a4.8 4.8 0 0 1 2.14-4.09L7.8 5.21l.63-.64L9.95 6.1a5 5 0 0 1 3.11-.33q.52.12 1 .33l1.51-1.52.63.64-1.34 1.34a5 5 0 0 1 2.14 4.1v.7zm7.65-1.64a.7.7 0 0 0 .2-.5.7.7 0 0 0-.2-.51.7.7 0 0 0-.5-.21.7.7 0 0 0-.52.2.7.7 0 0 0-.2.51q0 .3.2.51.21.2.51.2a.7.7 0 0 0 .51-.2m-4.28 0a.7.7 0 0 0 .2-.5.7.7 0 0 0-.2-.51.7.7 0 0 0-.51-.21.7.7 0 0 0-.51.2.7.7 0 0 0-.2.51q0 .3.2.51.2.2.5.2a.7.7 0 0 0 .52-.2m-1.91 8.75A4.8 4.8 0 0 1 7 14.93v-2.86h10v2.86q0 2.1-1.46 3.54A4.8 4.8 0 0 1 12 19.93q-2.1 0-3.54-1.46"
      />
    </svg>
  </span>
</template>
